// src/components/ErrorBoundary.tsx
'use client';

import { Component, ReactNode } from 'react';
import { Alert, AlertTitle } from '@mui/material';

type Props = { children: ReactNode };
type State = { hasError: boolean; message?: string };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message };
  }

  componentDidCatch(error: Error, info: any) {
    // You can also log to an external service here
    console.error('ErrorBoundary caught error', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert severity="error">
          <AlertTitle>Unexpected Error</AlertTitle>
          {this.state.message ?? 'Qualcosa è andato storto.'}
        </Alert>
      );
    }
    return this.props.children;
  }
}
